require('intersection-observer');
const lozad = require('lozad');

module.exports = function lazyLoadedImages() {
  const observer = lozad('.lozadImage');

  observer.observe();
};
